window.$catalog_discipline_page_number = 1;
window.$catalog_discipline_Glist = [];
window.$catalog_discipline_selectedRow = [];
window.$catalog_discipline_content = [];
window.$catalog_discipline_refresh = function(){};
window.$catalog_discipline_lastUsedTableFilter = {
  content: [],
  definitions: [],
};
window.$catalog_discipline_columnList = [];
window.$catalog_discipline_actions = [
  {
    id: "787cf96e-0c70-4b20-8e4c-2ac70224b82c",
    text: "Beheereenheid toevoegen",
    class: "locate",
    modal: "beheereenheid_toevoegen",
  },
];
window.$catalog_discipline_algemeenNaam = [];

window.$catalog_discipline_scroll_change = false;
